<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="7" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
        <b-form-group label-cols-md="4" label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table small show-empty empty-text="Please wait while the competencies load." striped responsive stacked="md"
      caption-top :items="items" :current-page="currentPage" :per-page="perPage" :fields="fields" :filter="filter"
      @filtered="onFiltered" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
      <template v-slot:cell(created_at)="row">{{ moment(row.item.created_at).format('MM.DD.YY') }}</template>
      <template v-slot:cell(benchmark_count)="row">
         <span class="text-success" v-if="row.item.benchmark_count >= row.item.num_skills_required">
           Complete
         </span>
        <span v-else>
          {{ row.item.benchmark_count }}/{{ row.item.num_skills_required }}
        </span>
        </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button-group>
          <b-button @click.stop="row.toggleDetails" class="btn btn-success">
            <span class="icon icon-eye">
              {{ row.detailsShowing ? 'Hide' : 'View'}}</span>
          </b-button>
        </b-button-group>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <div v-html="row.item.description"></div>
          <p>The benchmark for this competency is: {{ row.item.benchmark }}</p>
          <p>The number of times you must achieve this score is: {{ row.item.num_skills_required }}</p>
        </b-card>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

  </div>
</template>

<script>
const items = [];
var moment = require("moment");
export default {
  props: ['competencies', 'user_role'],
  data() {
    return {
      moment: moment,
      items: this.competencies,
      role: this.user_role,
      fields: [
        { key: "title", label: "Competency" },
        { key: "standard", label: "Standard" },
        { key: "benchmark", label: "Benchmark" },
        { key: "benchmark_count", label: "Progress" },
        { key: "actions", label: "Details", class: "text-center" }
      ],
      filter: null,
      sortBy: null,
      sortDesc: false,
      currentPage: 1,
      perPage: 25,
      totalRows: this.competencies.length,
      pageOptions: [15, 25, 35, 50],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showFile(id) {
      window.location.href = ('/instructor/competency/file/download/' + id);
    }
  }
};
</script>

<!-- table-complete-1.vue -->